import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Globe = ({
  size,
  type,
  theme,
  className,
  dataTestId = "globe-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.225 4.667h2.894A11.925 11.925 0 0 1 6.53 1.496a6.677 6.677 0 0 0-4.306 3.17ZM8 1.71c-.215.29-.48.688-.745 1.186a10.56 10.56 0 0 0-.745 1.77h2.98a10.56 10.56 0 0 0-.745-1.77A9.643 9.643 0 0 0 8 1.711ZM9.821 6H6.18A11.153 11.153 0 0 0 6 8c0 .718.067 1.386.179 2H9.82c.112-.614.179-1.282.179-2s-.067-1.386-.179-2Zm1.353 4a12.517 12.517 0 0 0 0-4h3.188c.198.63.305 1.302.305 2s-.107 1.37-.305 2h-3.188ZM9.49 11.333H6.51c.218.684.481 1.276.745 1.77.266.498.53.896.745 1.187.215-.291.48-.69.745-1.187.264-.494.527-1.086.745-1.77Zm-2.96 3.171a11.926 11.926 0 0 1-1.412-3.171H2.226a6.678 6.678 0 0 0 4.306 3.171ZM1.639 10h3.188a12.52 12.52 0 0 1-.16-2c0-.711.06-1.378.16-2H1.638a6.664 6.664 0 0 0-.305 2c0 .698.107 1.37.305 2Zm7.831 4.504a11.923 11.923 0 0 0 1.412-3.171h2.894a6.678 6.678 0 0 1-4.306 3.171Zm4.306-9.837h-2.894A11.923 11.923 0 0 0 9.47 1.496a6.678 6.678 0 0 1 4.306 3.17ZM.545 5.09a8.003 8.003 0 0 1 14.91 5.818A8.003 8.003 0 0 1 .544 5.091Z"
    />
  </SVGIcon>
);
